import React from "react";
import {Modal as BootStrapModal} from "react-bootstrap";
import styles from "./FreePlanSuccessModal.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle, faRocket} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";

export default function FreePlanSuccessModal({show, message, planName, onClose}) {
    const {t} = useTranslation();
    return (
        <BootStrapModal show={show} onHide={onClose} centered>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <div className={styles.successIcon}>
                        <FontAwesomeIcon icon={faCheckCircle} />
                    </div>
                    <h2 className={styles.title}>{t('pricing.planActivated')}</h2>
                    <p className={styles.subtitle}>
                        {message || t('pricing.planActivatedMessage', {planName: planName || t('common.freePlan')})}
                    </p>
                </div>

                <div className={styles.body}>
                    <div className={styles.celebrationIcon}>
                        <FontAwesomeIcon icon={faRocket} />
                    </div>
                    <p className={styles.description}>
                        {t('pricing.planActivatedDescription')}
                    </p>
                </div>

                <div className={styles.footer}>
                    <button className={styles.closeButton} onClick={onClose}>
                        {t('pricing.getStarted')}
                    </button>
                </div>
            </div>
        </BootStrapModal>
    );
}
